export default {"src":"/_next/static/media/NerdSquare.9c605d79.svg","height":48,"width":60};